import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

  totalRequest: number;

  constructor(private loadingService: LoadingService) {
    this.totalRequest = 0;
  }

  ngOnInit(): void {
    this.loadingService.loading.subscribe( req => {
      this.totalRequest = (this.totalRequest + req) >= 0 ? (this.totalRequest + req) : 0;
    });
  }

}
